module.exports = __webpack_public_path__ + "img/data-diri.ae2c111c.svg";